import BlockLogin from '@/components/blocks/Auth/BlockLogin';
import BlockForgotPassword from '@/components/blocks/Auth/BlockForgotPassword';
import BlockResetPassword from '@/components/blocks/Auth/BlockResetPassword';

export default [
	{
		path: '/login',
		name: 'Login',
		component: BlockLogin,
		meta: {
			title: `Login - ${process.env.VUE_APP_NAME}`
		}
	},
	{
		path: '/forgot-password',
		name: 'Forgot Password',
		component: BlockForgotPassword,
		meta: {
			title: `Forgot Password - ${process.env.VUE_APP_NAME}`
		}
	},
	{
		path: '/reset-password/:token',
		name: 'Reset Password',
		component: BlockResetPassword,
		meta: {
			title: `${setOrReset()} - ${process.env.VUE_APP_NAME}`
		}
	}
];

export function setOrReset() {
	const url = new URL(window.location.href);
	let action = false;

	action = !!url.searchParams.get('invite');

	return action ? 'Set Password' : 'Reset Password';
}
